module.exports = __webpack_public_path__ + "img/text.a1386e4c.png";